var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mesage"},[_c('ModalVue',{on:{"close":_vm.close}},[_c('div',{staticClass:"box"},_vm._l((_vm.message.content),function(text,i){return _c('p',{key:i},[_vm._v(" "+_vm._s(text)+" ")])}),0)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }